import React from 'react'
import LocalizedLegalDocument from './LocalizedLegalDocument'

export default function ChildSafetyStandards() {
  return <LocalizedLegalDocument documentKey='childSafety' />
}
